<template>
  <div>
    <b-navbar type="dark" variant="utb-blue" fixed="top">
      <b-navbar-brand href="#"><img src="images/logo_utb_blanco.png" alt="Logo"></b-navbar-brand>
    </b-navbar>
    <b-container class="mt-3 clear-navbar">
      <h2 class="app-name text-center text-primary">Actualiza UTB</h2>
      <h3 class="text-center">Muchas gracias por participar</h3>
      <p>
        Recuerda que la actualización de datos es obligatoria
      </p>
      <p v-if="redirectTo">
        Seras redirigido a {{ redirectTo }} en 5 segundos, o click <a href="" @click.prevent="redirect">aquí</a> para salir inmediatamente
      </p>
    </b-container>
  </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator'

import { redirect } from '../../services/redirect_service'
import { oauth } from '../../services/oauth_service'

@Component
export default class Logout extends Vue {
  redirectTo: string
  redirect() {
    window.location.assign(this.redirectTo)
  }
  async created() {
    this.redirectTo = redirect.redirectTo
    redirect.clear()
    if (this.redirectTo) {
      let self = this
      setTimeout(function () {
        self.redirect()
      }, 5000)
    }
  }
}
</script>